export class TaskService {
  client: any;
  constructor({client}: any) {
    this.client = client;
  }
  serviceName = 'app_tasks';

  getTasks(params: any) {
    return this.client.get(`${this.serviceName}`, params);
  }

  postTask(params: any) {
    return this.client.post(`${this.serviceName}`, params);
  }

  updateTask(params: any) {
    return this.client.put(`${this.serviceName}`, params);
  }

  getStatusByUser(users: number[], code: string) {
    const userParams = users.map((user) => `users_ids=${user}`).join('&');
    return this.client.get(`${this.serviceName}/status_by_user?code=${code}&${userParams}`);
  }
}
